import { Component, OnInit, Input, EventEmitter, Output, OnChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tercero } from '../../models/tercero';
import { TerceroService, CrearTerceroServiceRequest, EditarTerceroServiceRequest, TipoTercero, OrdenTercero } from '../../services/tercero-service.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Municipio } from '../../models/municipio';
import { Departamento } from '../../models/departamento';
import { fuseAnimations } from '@fuse/animations';
import { LoadingComponent } from 'app/common/loading/loading.component';
import { AlertDialogComponent } from 'app/common/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-tercero-registro',
    templateUrl: './tercero-registro.component.html',
    styleUrls: ['./tercero-registro.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class TerceroRegistroComponent implements OnChanges {

    constructor
    (
        private _formBuilder: FormBuilder,
        private _terceroService: TerceroService,
        private _matDialog:MatDialog,
        private _snackBar: MatSnackBar
    ) { }


    @Input() accion: string; /** registrar/editar/detalle **/
    @Input() terceroId: number;
    @Input() camposAConfirmar:string[];
    @Output() onRegistroTercero = new EventEmitter();
    @Output() onEditarTercero = new EventEmitter();

    public inicializandoFormulario:boolean = false;
    public tercero: Tercero;
    public terceroCreateForm: FormGroup;
    public departamentos: Departamento[];
    public tiposTerceros: TipoTercero[];
    public ordenesTercero: OrdenTercero[];
    public municipios: Municipio[];
    public mascara:string = '0000009999';
    public dateNow:Date = new Date();

    ngOnChanges() {
        this.getDepartamentos();
        this.tercero = new Tercero();
        this.terceroCreateForm = this.InicializarTerceroForm();
        let changeEvent = new MatSelectChange(null, this.tercero.departamento);
        this.getMunicipios(changeEvent);
        this.getTiposTerceros();
        this.getOrdenesTerceros();
        switch (this.accion) {
            case "editar":
            case "detalle":
                this.ConsultarTercero();
                break;
        }
    }

    private getDepartamentos() {
        let loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
        this._terceroService.GetDepartamentos()
            .subscribe(response => {
                loading.close();
                this.departamentos = response;
            });
    }

    public getMunicipios(selectChangeEvent: MatSelectChange) {
        let loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
        this._terceroService.GetMunicipios(selectChangeEvent.value)
            .subscribe(response => {
                loading.close();
                this.municipios = response;
            });
    }

    public getTiposTerceros() {
        this._terceroService.GetTiposTerceros()
            .subscribe(response => {
                this.tiposTerceros = response;
            });
    }

    public CambioTipoPersona(){
        const tipoPersona = this.terceroCreateForm.get("tipoPersona").value;
        if(tipoPersona != 'Natural')
            this.CalcularDigitoVerificacion();
    }
    public CambioTipoIdentificacion(){
        const tipoIdentificacion = this.terceroCreateForm.get("tipoIdentificacion").value,
            fechaNacimientoControl = this.terceroCreateForm.get('fechaNacimiento');
        if(tipoIdentificacion == 'NIT'){
            this.mascara = '000000000';
            fechaNacimientoControl.clearValidators();
        }
        else{
            this.mascara = '0000009999';
            fechaNacimientoControl.setValidators(Validators.required);
        }
        fechaNacimientoControl.updateValueAndValidity();
        this.CalcularDigitoVerificacion();
    }
    public CambioIdentificacion(): void {
        const identificacion = this.terceroCreateForm.get("identificacion").value;
        if (this.accion != "registrar") return; 
        this._terceroService.VerificarTerceroNoExista(identificacion)
        .subscribe(response => {
            if (response && response.error) {
                this._snackBar.open(response.mensaje);
                return;
            }
        })        
        this.CalcularDigitoVerificacion();
    }

    private CalcularDigitoVerificacion(){
        const identificacion = this.terceroCreateForm.get("identificacion").value;
        this.terceroCreateForm.get("dv").setValue(undefined);
        if(!identificacion) return;

        this._terceroService.CalcularDigitoVerificacion(identificacion)
        .subscribe(response => {
            if(!response) return;
            this.terceroCreateForm.get("dv").setValue(response);
        });
    }

    private ConsultarTercero() {
        if (!this.terceroId) return;
        let loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
        this._terceroService.FindById(this.terceroId)
            .subscribe(response => {
                loading.close();
                if (response) {
                    this.tercero = response.tercero;
                    let changeEvent = new MatSelectChange(null, this.tercero.departamento);
                    this.getMunicipios(changeEvent);
                    this.limpiarCamposQueDebenSerReconfirmados();
                    this.MapearDatosTerceroEnFormulario();
                } else {
                    this.onEditarTercero.emit(new EventRegistroTerceroResponse());
                }
            });
    }

    private limpiarCamposQueDebenSerReconfirmados(){
        if(!this.camposAConfirmar) return;
        this.camposAConfirmar.forEach(t => {
            this.tercero[t] = "";
        })
    }

    private MapearDatosTerceroEnFormulario(){
        this.inicializandoFormulario = true;
        this.terceroCreateForm.patchValue({
            tipoVinculacion: this.tercero.tipoVinculacion,
            tipoPersona: this.tercero.tipoPersona,
            tipoIdentificacion: this.tercero.tipoIdentificacion,
            identificacion: this.tercero.identificacion,
            dv: this.tercero.dv,
            primerNombre: this.tercero.primerNombre,
            segundoNombre: this.tercero.segundoNombre,
            primerApellido: this.tercero.primerApellido,
            segundoApellido: this.tercero.segundoApellido,
            id: this.tercero.id,
            consorcioUnionTemporal: this.tercero.consorcioUnionTemporal,
            unionTemporalConsorcio: this.tercero.unionTemporalConsorcio || false,
            razonSocial: this.tercero.razonSocial,
            telefono: this.tercero.telefono,
            correoElectronico: this.tercero.correoElectronico,
            fechaNacimiento: this.tercero.fechaNacimiento,
            departamento: this.tercero.departamento,
            municipio: this.tercero.municipio,
            direccion: this.tercero.direccion,
            ordenId: this.tercero.ordenId,
        })
        this.inicializandoFormulario = false;

        if(this.tercero.tipoPersona == "Juridica") {
            this.terceroCreateForm.get("ordenId").setValidators([Validators.required]);
            this.terceroCreateForm.get("ordenId").updateValueAndValidity();
        }

        this.CambioTipoIdentificacion();
    }

    public puedeGuardarTercero():boolean{
        return this.terceroCreateForm.valid;
    }
    public guardarTercero(){
        let direccion:string[] = this.terceroCreateForm.value.direccion?.split("") || [];
        const espaciosEnBlancoEnDireccionMinimoPermitidos = 2,
            espaciosEnBlancoEnDireccion = direccion.filter(t => {return t == " "}).length;
        if(espaciosEnBlancoEnDireccion < espaciosEnBlancoEnDireccionMinimoPermitidos){
            this._matDialog.open(AlertDialogComponent,{
                panelClass: 'alert',
                data: {
                    titulo: "¡Advertencia!",
                    mensaje: `Estimado usuario: <br><br> Por favor verifique la dirección ingresada, 
                                el valor "<b><em>${this.terceroCreateForm.value.direccion}</em></b>" NO corresponde
                                a una dirección válida.
                                <br><br><b>Nota:</b> Tenga en cuenta que si la dirección ingresada es incorrecta, 
                                su proceso de pago puede verse afectado.`
                }
            })
            return;
        }
        if(!this.terceroId){
            this.RegistrarNuevoTercero();
        }else{
            this.ActualizarTercero();
        }
    }

    private RegistrarNuevoTercero() {
        let request = new CrearTerceroServiceRequest();
        request.Tercero = this.terceroCreateForm.value;
        request.Tercero.dv = request.Tercero.dv ? request.Tercero.dv.toString() : undefined;
        this.LimpiarTipoTercero(request.Tercero);
        if (!request.Tercero.unionTemporalConsorcio && !request.Tercero.identificacion) {
            this._snackBar.open("La identificación es obligatoria", "", { duration: 5000 });
			return
        }
        if (request.Tercero.unionTemporalConsorcio && !request.Tercero.consorcioUnionTemporal) {
            this._snackBar.open("Debe especificar si es consorcio o unión temporal", "", { duration: 5000 });
			return
        }
        let loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
        this._terceroService.CrearTercero(request)
            .subscribe(response => {
                loading.close();
                if(!response) return;
                let objeto: EventRegistroTerceroResponse = { mensaje: response.mensaje, tercero: response.tercero };
                this.onRegistroTercero.emit(objeto);
                this._snackBar.open(response.mensaje, "", { duration: 5000 });
            })
    }

    private LimpiarTipoTercero(tercero: Tercero): void {
        if (!tercero.unionTemporalConsorcio) { tercero.consorcioUnionTemporal = null; }
    }

    private ActualizarTercero() {
        let request = new EditarTerceroServiceRequest();
        request.Tercero = this.terceroCreateForm.getRawValue();
        request.Tercero.dv = request.Tercero.dv ? request.Tercero.dv.toString() : undefined;
        if (!request.Tercero.identificacion) {
            this._snackBar.open("La identificación es obligatoria", "", { duration: 5000 });
            return
        }
        this.LimpiarTipoTercero(request.Tercero);
        if (request.Tercero.unionTemporalConsorcio && !request.Tercero.consorcioUnionTemporal) {
            this._snackBar.open("Debe especificar si es consorcio o unión temporal", "", { duration: 5000 });
            return
        }
        let loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
        this._terceroService.EditarTercero(request)
            .subscribe(response => {
                loading.close();
                if(!response) return;
                let objeto: EventRegistroTerceroResponse = { mensaje: response.mensaje, tercero: response.tercero };
                this.onEditarTercero.emit(objeto);
                this._snackBar.open(response.mensaje, "", { duration: 5000 });
            })
    }

    private InicializarTerceroForm(): FormGroup {
        let form = this._formBuilder.group({
            tipoVinculacion: [{ value: this.tercero.tipoVinculacion, disabled: this.accion == "detalle" }, [Validators.required]],
            tipoPersona: [{ value: this.tercero.tipoPersona, disabled: this.accion == "detalle" }, [Validators.required]],
            tipoIdentificacion: [{ value: this.tercero.tipoIdentificacion, disabled: this.accion == "detalle" }, [Validators.required]],
            identificacion: [{ value: this.tercero.identificacion, disabled: (this.accion == "detalle" /*|| this.accion == "editar"*/) }, []],
            dv: [{ value: this.tercero.dv, disabled: (this.accion == "detalle" /*|| this.accion == "editar"*/) }, [Validators.minLength(1), Validators.maxLength(1)]],
            primerNombre: [{ value: this.tercero.primerNombre, disabled: this.accion == "detalle" }],
            segundoNombre: [{ value: this.tercero.segundoNombre, disabled: this.accion == "detalle" }],
            primerApellido: [{ value: this.tercero.primerApellido, disabled: this.accion == "detalle" }],
            segundoApellido: [{ value: this.tercero.segundoApellido, disabled: this.accion == "detalle" }],
            id: [{ value: this.tercero.id, disabled: this.accion == "detalle" }],
            consorcioUnionTemporal: [{ value: this.tercero.consorcioUnionTemporal, disabled: this.accion == "detalle" }],
            unionTemporalConsorcio: [{ value: this.tercero.unionTemporalConsorcio || false, disabled: this.accion == "detalle" }, [Validators.required]],
            razonSocial: [{ value: this.tercero.razonSocial, disabled: this.accion == "detalle" }],
            telefono: [{ value: this.tercero.telefono, disabled: this.accion == "detalle" }, [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
            correoElectronico: [{ value: this.tercero.correoElectronico, disabled: this.accion == "detalle" }, [Validators.required, Validators.email]],
            departamento: [{ value: this.tercero.departamento, disabled: this.accion == "detalle" }, [Validators.required]],
            municipio: [{ value: this.tercero.municipio, disabled: this.accion == "detalle" }, [Validators.required]],
            direccion: [{ value: this.tercero.direccion, disabled: this.accion == "detalle" }, [Validators.required]],
            fechaNacimiento: [{ value: this.tercero.fechaNacimiento, disabled: this.accion == "detalle" }, []],
            ordenId: [{value: this.tercero.ordenId, disabled: this.accion == "detalle" }, []]
        });
        
        form.controls.unionTemporalConsorcio.valueChanges.subscribe(esUnionTemporalOConsorcio => {
            if(this.inicializandoFormulario) return;
            if (esUnionTemporalOConsorcio) {
                form.controls.identificacion.setValidators([]);
                form.controls.dv.setValidators([]);                
            }else{
                form.controls.identificacion.setValidators([Validators.required]);
                if(form.controls.tipoPersona.value == 'Juridica'){
                    form.controls.dv.setValidators([Validators.required]);
                }
            }
            form.updateValueAndValidity();
        });

        form.controls.tipoPersona.valueChanges.subscribe(tipoPersonaSeleccionado => {
            if(this.inicializandoFormulario) return;
            if (tipoPersonaSeleccionado == 'Natural') {
                form.controls.primerNombre.setValidators([Validators.required]);
                form.controls.segundoNombre.setValidators([]);
                form.controls.primerApellido.setValidators([Validators.required]);
                form.controls.segundoApellido.setValidators([Validators.required]);
                form.controls.dv.setValidators([]);
                form.controls.razonSocial.setValidators([]);
                form.controls.ordenId.setValidators([]);
                
                if(form.controls.unionTemporalConsorcio.value){
                    form.controls.identificacion.setValidators([]);
                }else{
                    form.controls.identificacion.setValidators([Validators.required]);
                }
            }

            if (tipoPersonaSeleccionado == 'Juridica') {
                form.controls.primerNombre.setValidators([]);
                form.controls.segundoNombre.setValidators([]);
                form.controls.primerApellido.setValidators([]);
                form.controls.segundoApellido.setValidators([]);
                form.controls.dv.setValidators([Validators.required]);
                form.controls.razonSocial.setValidators([Validators.required]);
                form.controls.ordenId.setValidators([Validators.required]);

                if(form.controls.unionTemporalConsorcio.value){
                    form.controls.identificacion.setValidators([]);
                    form.controls.dv.setValidators([]);
                }else{
                    form.controls.identificacion.setValidators([Validators.required]);
                    form.controls.dv.setValidators([Validators.required]);
                }
            }
            form.updateValueAndValidity();
        });

        return form;
    }

    public getOrdenesTerceros() {
        this._terceroService.getOrdenesTercero()
            .subscribe(response => {
                this.ordenesTercero = response;
            });
    }
}

export class EventRegistroTerceroResponse {
    public mensaje: string;
    public tercero: Tercero;
}